import useCustomToast from 'hooks/useCustomToasts';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../actions/parametrosPago.action';

/**
 *
 * @param {string} codProducto
 * @returns {{
 *    fetchParametros: Function,
 *    handleContinue: Function,
 *    setCombos: Function,
 *    loading: boolean,
 *    error: any
 *    parametros: any
 * }}
 */
const useParametrosPago = (codProducto) => {
  const dispatch = useDispatch();
  /**
   * @type {{loading:boolean,parametros:any,error:any}}
   */
  const state = useSelector((state) => state.ParametrosPagoReducer);
  const { addWarningToast } = useCustomToast();

  /**
   *
   * @param {string} producto
   */
  const fetchParametros = useCallback(
    (producto = codProducto, idCarrito = null) => {
      dispatch(actions.getParametrosPago(producto, idCarrito));
    },
    [codProducto, dispatch]
  );

  /**
   *
   * @param {{
   *  formaPago: string,
   *  idPlazo: string,
   *  setShowLogos: CallableFunction,
   *  setshowOpciones: CallableFunction,
   *  reset: CallableFunction
   * }} param0
   */
  const setCombos = ({
    formaPago,
    idPlazo,
    setShowLogos,
    setshowOpciones,
    reset,
    extraData = {},
  }) => {
    // try {
    if (state?.parametros) {
      console.log(state);
      const { formasPago, plazos } = state?.parametros;
      const defaultData = {};

      if (formaPago === 'contado' && formasPago) {
        const forma = formasPago.find((e) => Number(e.value.id) === Number(idPlazo));
        defaultData.formaPago = forma?.value;
      } else {
        //mesesSinIntereses
        const item = formasPago.find((e) => e.value.tipo === formaPago);

        defaultData.formaPago = item?.value;
        const plazo = plazos.find((e) => Number(e.value.ID) === Number(idPlazo));
        defaultData.idPlazo = plazo?.value;
        setShowLogos && setShowLogos(true);
        setshowOpciones && setshowOpciones(true);
      }
      reset({ ...extraData, ...defaultData });
    }
  };

  const handleContinue = (callback) => (evt) => {
    if (state.error) {
      return addWarningToast(state?.error?.message);
    }
    callback(evt);
  };
  return {
    ...state,
    fetchParametros,
    setCombos,
    handleContinue,
    error: state.error?.message,
  };
};

export default useParametrosPago;
